import { create } from "zustand";
import { Profile } from "../models/Profile";
import { Crate } from "../models/Crate";
import { addMaterialToCrate, createCrate, deleteCrate, deleteMaterialFromCrate, getAllCrates, getCrate, getCrateByCode, updateCrate } from "../repositories/CrateRepository";

export interface MaterialStore {
  fetchCrates: (user: Profile) => Promise<Crate[] | undefined>;
  fetchCrate: (user: Profile, id: number) => Promise<Crate | undefined>;
  fetchCrateByCode: (user: Profile, crateCode: string) => Promise<Crate | undefined>;
  addMaterialToCrate: (user: Profile, crateId: number, materialId: number) => Promise<number | undefined>;
  removeMaterialFromCrate: (user: Profile, crateId: number, materialId: number) => Promise<number | undefined>
  addCrate: (
    user: Profile,
    crateType: string
  ) => Promise<number | undefined>;
  editCrate: (
    user: Profile,
    crate: Crate,
    crateId: number
  ) => Promise<number | undefined>;
  removeCrate: (
    user: Profile,
    crateId: number
  ) => Promise<number | undefined>;
}

export const useCrate = create<MaterialStore>(() => ({
  fetchCrates: (user) => {
    return getAllCrates(user);
  },
  fetchCrate: (user, id) => {
    return getCrate(user, id)
  },
  fetchCrateByCode: (user, code) => {
    return getCrateByCode(user, code)
  },
  addMaterialToCrate: (user, crateId, materialId) => {
    return addMaterialToCrate(user, crateId, materialId)
  },
  removeMaterialFromCrate: (user, crateId, materialId) => {
    return deleteMaterialFromCrate(user, crateId, materialId);
  },
  addCrate: (user, crateType) => {
    return createCrate(user, crateType);
  },
  editCrate: (user, material, materialId) => {
    return updateCrate(user, material, materialId);
  },
  removeCrate: (user, materialId) => {
    return deleteCrate(user, materialId);
  },
}));
